import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type { IamMemberListResult, IamOrganizationNode } from './types/member';

const request = createAppRequest();

export async function searchIamMembers(
  params?: {
    pageNo?: number;
    pageSize?: number;
    keyword?: string;
    departmentId?: string;
    includeChildrenNodes?: boolean;
  },
  options?: ApiRequestOptions,
) {
  return request<IamMemberListResult>('/bff/iam-ui/members', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getIamOrganizationTree(options?: ApiRequestOptions) {
  return request<IamOrganizationNode[]>('/bff/iam-ui/organizations/tree', {
    method: 'GET',
    ...(options || {}),
  });
}
